/* Native Shopify search, product selection, cart and checkout remain in Dawn. */
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-hl-sort] select')) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }
});
document.documentElement.classList.add('hl-js');
